// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j1--M","comment":"styles_comment__3zCxh"};